module.exports = __webpack_public_path__ + "img/永信.png";